import { CalendarClock, FileText, MessageCircle, ReceiptEuro, type LucideIcon } from 'lucide-react'

import type { CaarlDirectAccess } from '@orus.eu/backend'
import { GuideBookIllustration } from '@orus.eu/pharaoh-next/components/illustrations/artworks/guide-book'
import { ManagerIllustration } from '@orus.eu/pharaoh-next/components/illustrations/artworks/manager'
import { MessageIllustration } from '@orus.eu/pharaoh-next/components/illustrations/artworks/message'
import { MoneyHouseIllustration } from '@orus.eu/pharaoh-next/components/illustrations/artworks/money-house'
import type { IllustrationComponent } from '@orus.eu/pharaoh-next/components/illustrations/illustration'
import type { ParameterlessTranslationKey } from '@orus.eu/translations'

export type LegalAssistanceRequest = {
  directAccess: CaarlDirectAccess
  titleKey: ParameterlessTranslationKey
  descriptionKey: ParameterlessTranslationKey
  actionKey: ParameterlessTranslationKey
  icon: LucideIcon
  illustration: IllustrationComponent
}

/** The four entry points CAARL exposes, in the order the screen offers them. */
export const legalAssistanceRequests: LegalAssistanceRequest[] = [
  {
    directAccess: 'rendezVousJuridique',
    titleKey: 'lawyer_consultation',
    descriptionKey: 'lawyer_consultation_paragraph',
    actionKey: 'book_a_slot',
    icon: CalendarClock,
    illustration: ManagerIllustration,
  },
  {
    directAccess: 'documentationJuridique',
    titleKey: 'legal_documents',
    descriptionKey: 'legal_documents_paragraph',
    actionKey: 'generate_documents',
    icon: FileText,
    illustration: GuideBookIllustration,
  },
  {
    directAccess: 'chatbot',
    titleKey: 'ask_a_question',
    descriptionKey: 'ask_a_question_paragraph',
    actionKey: 'open_the_legal_chatbot',
    icon: MessageCircle,
    illustration: MessageIllustration,
  },
  {
    directAccess: 'recouvrementFacture2',
    titleKey: 'unpaid_invoices',
    descriptionKey: 'unpaid_invoices_paragraph',
    actionKey: 'access_requests',
    icon: ReceiptEuro,
    illustration: MoneyHouseIllustration,
  },
]
